import React, { useRef, useEffect, useState } from 'react'
import { useWindowSize } from '@react-hook/window-size'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'

import { ScrollParallax } from 'components/motion/parallax'
import useUIContext from 'context/ui'

import { desktop } from 'styles/config/_breakpoints.scss'

import Credit from './Credit'
import { Headline3 } from 'components/ui/Typography'
import ThemeWaypoint from 'components/ui/ThemeWaypoint'

import s from './Credits.module.scss'
import HorizontalWapper from '../HorizontalWrapper'
const cn = classNames.bind(s)

const Credits = ({ data, themeWaypoint = 'dark' }) => {
  const { primary, fields } = data
  const [viewportWidth, viewportHeight] = useWindowSize(0)
  const scrollX = useUIContext((s) => s.scrollX)
  const sizerRef = useRef(null)
  const innerRef = useRef(null)
  const [offset, setOffset] = useState(0)
  const [isParallaxActive, setIsParallaxActive] = useState(false)

  useEffect(() => {
    if (!sizerRef.current || !innerRef.current || !isParallaxActive) return
    setOffset(innerRef.current.clientHeight - sizerRef.current.clientHeight - viewportHeight / 2)
  }, [sizerRef, innerRef, viewportWidth, viewportHeight, isParallaxActive])

  // set virtual scrollbar depending on the viewport size
  useEffect(() => {
    setIsParallaxActive(viewportWidth >= parseInt(desktop))
  }, [viewportWidth])

  return (
    <HorizontalWapper>
      {themeWaypoint !== 'none' && <ThemeWaypoint className={cn('waypoint')} after={themeWaypoint} />}
      <div ref={innerRef} className={cn('inner')}>
        <ScrollParallax
          motionValue={scrollX}
          keyframes={{ y: [isParallaxActive ? viewportHeight / 2 : 0, offset] }}
          horizontal
          disabled={!isParallaxActive}
          // key={isParallaxActive} // make sure we remount when direction changes
        >
          <div ref={sizerRef}>
            <div className={cn('title')}>
              <Headline3>{primary.section_title[0].text}</Headline3>
            </div>
            <ul className={cn('list')}>
              {fields.map((field, i) => (
                <Credit key={i} name={field.name[0].text} role={field.role[0].text} />
              ))}
            </ul>
          </div>
        </ScrollParallax>
      </div>
    </HorizontalWapper>
  )
}

Credits.propTypes = {
  data: PropTypes.object,
  themeWaypoint: PropTypes.oneOf(['light', 'dark', null]),
}

export default Credits
